import { CheckboxWrapper, StyledCheckbox, StyledLabel,
     CheckboxWrapperContainer } from './Checkbox.styled';
import React from 'react';

const Checkbox = ({
    id,
    key,
    value,
    checked,
    onCheckboxSelectionChange,
    label,
    width,
    height,
    margin,
    disabled,
    labelStyleObj,
    checkedBgColor,
    checkboxBorder,
    background,
    name,
    marginRight,
    alignItemDirection,
    hoverEffect,
    disableFocusEffect,
    checkIconSize,
    checkboxWrapperDisplay,
    isLabelClick = true,
    ariaLabel,
    justifyContent='',
    isSurgeryReviewPage = false,
    isConsignmentReviewPage = false
}) => {


    // Handler for label click
    const handleLabelClick = (e) => {
        if (disabled) return;
        e.preventDefault();
        if (typeof onCheckboxSelectionChange === 'function') {
            onCheckboxSelectionChange({
                originalEvent: e,
                value: !checked,
                checked: !checked,
                target: { id, name, checked: !checked },
            });
        }
    };
       return (
        <CheckboxWrapperContainer
            isSurgeryReviewPage={isSurgeryReviewPage}
            isConsignmentReviewPage={isConsignmentReviewPage}
            id={id ? `${id}-wrapper` : undefined}
        >
            <CheckboxWrapper
                alignItemDirection={alignItemDirection}
                checkboxWrapperDisplay={checkboxWrapperDisplay}
                data-testid="checkbox-wrapper"
                justifyContent={justifyContent}
            >
                <StyledCheckbox
                    data-testid="styled-checkbox"
                    inputId={id}
                    key={key}
                    value={value}
                    checked={checked}
                    onChange={onCheckboxSelectionChange}
                    width={width}
                    height={height}
                    margin={margin}
                    disabled={disabled}
                    checkedBgColor={checkedBgColor}
                    checkboxBorder={checkboxBorder}
                    background={background}
                    name={name}
                    marginRight={marginRight}
                    hoverEffect={hoverEffect}
                    disableFocusEffect={disableFocusEffect}
                    checkIconSize={checkIconSize}
                    ariaLabel={ariaLabel}
                />
                {label && (
                    <StyledLabel
                        htmlFor={isLabelClick ? id : undefined}
                        id={`${id}-label`}
                        disabled={disabled}
                        labelStyleObj={labelStyleObj}
                        data-testid="styled-label"
                        onClick={isLabelClick ? handleLabelClick : undefined}
                        style={isLabelClick ? { cursor: disabled ? 'not-allowed' : 'pointer' } : {}}
                    >
                        {label}
                    </StyledLabel>
                )}
            </CheckboxWrapper>
        </CheckboxWrapperContainer>
    );
};

export default Checkbox;
